import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";

import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import "flatpickr/dist/flatpickr.css";
import ImageUpload from "components/shared/ImageUpload";

const EditTestmonials = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { loading, error, section } = useSelector((state) => state.section);

  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  // const categoryDefaultValue = categories?.find(
  //   (category) => category?.slug === section?.category
  // )?.heading?.[locale];

  const {
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  // effects
  useEffect(() => {
    dispatch(getSection({ page: "testmonials", slug: id }));
  }, [dispatch, id]);

  useEffect(() => {
    reset(section);
    setSelectedImage({
      preview: null,
      path: section?.image,
    });
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    if (!selectedImage?.path) {
      toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
      return;
    }

    data.image = `/uploads/${selectedImage?.path?.split("/").at(-1)}`;

    dispatch(
      editSection({
        slug: id,
        page: "testmonials",
        data: { section: data },
        navigate,
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"editItem"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={8} md={12}>
                <Row>
                  <Col lg={8} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id={"item"} />
                      </h5>
                      <ImageUpload
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                        accept="image/*, video/*"
                        className="w-auto"
                      />
                    </div>
                  </Col>
                </Row>

                <SaveChangesButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditTestmonials;
